<template>
    <div class="grid grid-cols-2">
        <div class="www pt-4 pb-2 select-none">
            <label
                for="i-color"
                class="block pb-2 text-sm font-medium text-gray-700"
            >
                {{ t('templateTextColor') }}
            </label>
            <div
                ref="colorWidget"
                :class="[
                    !stateRepository.states.color
                        ? 'text-gray-300 hover:text-gray-300'
                        : 'text-gray-500 hover:bg-gray-200 hover:text-gray-700',
                    'relative inline-block flex-none text-sm',
                ]"
            >
                <button
                    class="flex p-1"
                    :disabled="!stateRepository.states.color"
                    @click="colorOpen = true"
                >
                    <MdiFormatColorText class="h-6 w-6" />
                    <MdiChevronDown class="h-6 w-4" />
                    <div
                        class="inline-block h-6 w-9 border border-gray-400 text-sm"
                        :style="`background-color: ${members.color};`"
                    ></div>
                </button>

                <div
                    :class="[
                        colorOpen === true ? 'absolute top-full left-0' : 'hidden',
                        'flex flex-col',
                    ]"
                >
                    <color-picker
                        v-model:pure-color="pureColor"
                        v-model:gradient-color="defaultGradient"
                        picker-type="fk"
                        use-type="pure"
                        shape="square"
                        lang="en"
                        :is-widget="true"
                        :disable-alpha="true"
                    />
                    <ActionButton
                        :value="t('buttonUse')"
                        state="info"
                        :icon="MdiCheck"
                        class-override="rounded-t-none"
                        @click="changeColor(editor)"
                    />
                </div>
            </div>
        </div>
        <div class="www pt-4 pb-2 select-none">
            <label
                for="i-backgroundColor"
                class="block pb-2 text-sm font-medium text-gray-700"
            >
                {{ t('templateBackgroundColor') }}
            </label>
            <div
                ref="colorWidgetBg"
                :class="[
                    !stateRepository.states.color
                        ? 'text-gray-300 hover:text-gray-300'
                        : 'text-gray-500 hover:bg-gray-200 hover:text-gray-700',
                    'relative inline-block flex-none text-sm',
                ]"
            >
                <button
                    class="flex p-1"
                    :disabled="!stateRepository.states.color"
                    @click="colorOpenBg = true"
                >
                    <MdiPalette class="h-6 w-6" />
                    <MdiChevronDown class="h-6 w-4" />
                    <div
                        class="inline-block h-6 w-9 border border-gray-400 text-sm"
                        :style="`background-color: ${members.backgroundColor};`"
                    ></div>
                </button>

                <div
                    :class="[
                        colorOpenBg === true ? 'absolute top-full right-0' : 'hidden',
                        'flex flex-col',
                    ]"
                >
                    <color-picker
                        v-model:pure-color="pureColorBg"
                        v-model:gradient-color="defaultGradientBg"
                        picker-type="fk"
                        use-type="pure"
                        shape="square"
                        lang="en"
                        :is-widget="true"
                        :disable-alpha="true"
                    />
                    <ActionButton
                        :value="t('buttonUse')"
                        state="info"
                        :icon="MdiCheck"
                        class-override="rounded-t-none"
                        @click="changeColorBg(editor)"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="www pt-4 pb-2 select-none">
        <label
            for="i-backgroundImage"
            class="block text-sm font-medium text-gray-700"
        >
            {{ t('templateBackgroundImage') }}
        </label>
        <input
            id="i-backgroundImage"
            v-model="colorsConfig.backgroundImage"
            type="text"
            name="i-backgroundImage"
            autocomplete="off"
            class="mt-1 block w-full rounded-md border border-gray-300 px-2 py-1 text-sm shadow-sm focus:border-blue-500 focus:ring-blue-500 focus:outline-hidden"
            :disabled="!stateRepository.states.color"
            @change="changeBackgroundImage()"
        />
    </div>
    <div class="www pt-4 pb-2 select-none">
        <label
            for="i-backgroundRepeat"
            class="block text-sm font-medium text-gray-700"
        >
            {{ t('templateBackgroundRepeat') }}
        </label>
        <select
            id="i-backgroundRepeat"
            v-model="members.backgroundRepeat"
            name="i-backgroundRepeat"
            class="mt-1 block w-full rounded-md border border-gray-300 bg-white px-2 py-1 shadow-sm focus:border-blue-500 focus:ring-blue-500 focus:outline-hidden sm:text-sm"
            :disabled="!stateRepository.states.color"
        >
            <option
                v-for="r in backgroundRepeats"
                :key="r.value"
                :value="r.value"
            >
                {{ r.title }}
            </option>
        </select>
    </div>
    <div class="www pt-4 pb-2 select-none">
        <label
            for="i-backgroundRepeat"
            class="block text-sm font-medium text-gray-700"
        >
            {{ t('templateBackgroundSize') }}
        </label>
        <select
            id="i-backgroundSize"
            v-model="members.backgroundSize"
            name="i-backgroundSize"
            class="mt-1 block w-full rounded-md border border-gray-300 bg-white px-2 py-1 shadow-sm focus:border-blue-500 focus:ring-blue-500 focus:outline-hidden sm:text-sm"
            :disabled="!stateRepository.states.color"
        >
            <option
                v-for="r in backgroundSizes"
                :key="r.value"
                :value="r.value"
            >
                {{ r.title }}
            </option>
        </select>
    </div>
    <div class="www pt-4 pb-2 select-none">
        <label
            for="i-backgroundRepeat"
            class="block text-sm font-medium text-gray-700"
        >
            {{ t('templateBackgroundPositionX') }}
        </label>
        <select
            id="i-backgroundSize"
            v-model="members.backgroundPositionX"
            name="i-backgroundSize"
            class="mt-1 block w-full rounded-md border border-gray-300 bg-white px-2 py-1 shadow-sm focus:border-blue-500 focus:ring-blue-500 focus:outline-hidden sm:text-sm"
            :disabled="!stateRepository.states.color"
        >
            <option
                v-for="r in backgroundPositionXs"
                :key="r.value"
                :value="r.value"
            >
                {{ r.title }}
            </option>
        </select>
    </div>
    <div class="www pt-4 pb-2 select-none">
        <label
            for="i-backgroundRepeat"
            class="block text-sm font-medium text-gray-700"
        >
            {{ t('templateBackgroundPositionY') }}
        </label>
        <select
            id="i-backgroundSize"
            v-model="members.backgroundPositionY"
            name="i-backgroundSize"
            class="mt-1 block w-full rounded-md border border-gray-300 bg-white px-2 py-1 shadow-sm focus:border-blue-500 focus:ring-blue-500 focus:outline-hidden sm:text-sm"
            :disabled="!stateRepository.states.color"
        >
            <option
                v-for="r in backgroundPositionYs"
                :key="r.value"
                :value="r.value"
            >
                {{ r.title }}
            </option>
        </select>
    </div>
</template>

<script setup>
    import { ref, reactive } from 'vue';
    import useClickOutside from '../composables/useClickOutside';
    import { t } from '../composables/i18n';
    import { ColorPicker } from 'vue3-colorpicker';
    import 'vue3-colorpicker/style.css';
    import {
        MdiFormatColorText,
        MdiPalette,
        MdiChevronDown,
        MdiCheck,
    } from 'materialdesignicons-vue3/icons/';
    import ActionButton from '../ui/ActionButton.vue';

    defineExpose({
        name: 'BackgroundWidget',
    });

    const props = defineProps({
        members: {
            type: Object,
            default: () => {
                return {};
            },
        },
        stateRepository: {
            type: Object,
            required: true,
        },
    });

    const backgroundRepeats = [
        {
            value: 'repeat',
            title: t('templateBackgroundRepeatRepeat'),
        },
        {
            value: 'repeat-x',
            title: t('templateBackgroundRepeatRepeatX'),
        },
        {
            value: 'repeat-y',
            title: t('templateBackgroundRepeatRepeatY'),
        },
        {
            value: 'no-repeat',
            title: t('templateBackgroundRepeatNoRepeat'),
        },
    ];

    const backgroundSizes = [
        {
            value: 'auto',
            title: t('templateBackgroundSizeAuto'),
        },
        {
            value: '100% auto',
            title: t('templateBackgroundSizeXAuto'),
        },
        {
            value: 'cover',
            title: t('templateBackgroundSizeCover'),
        },
        {
            value: 'contain',
            title: t('templateBackgroundSizeContain'),
        },
    ];

    const backgroundPositionXs = [
        {
            value: 'left',
            title: t('templateBackgroundPositionXLeft'),
        },
        {
            value: 'center',
            title: t('templateBackgroundPositionXCenter'),
        },
        {
            value: 'right',
            title: t('templateBackgroundPositionXRight'),
        },
    ];

    const backgroundPositionYs = [
        {
            value: 'top',
            title: t('templateBackgroundPositionYTop'),
        },
        {
            value: 'center',
            title: t('templateBackgroundPositionYCenter'),
        },
        {
            value: 'bottom',
            title: t('templateBackgroundPositionYBottom'),
        },
    ];

    const pureColor = ref('000000');
    const colorOpen = ref(false);
    const colorWidget = ref(null);
    const pureColorBg = ref('000000');
    const colorOpenBg = ref(false);
    const colorWidgetBg = ref(null);
    const defaultGradient = ref(
        'linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 100%)',
    );
    const defaultGradientBg = ref(
        'linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 100%)',
    );
    const members = props.members;
    const stateRepository = props.stateRepository;

    const colorsConfig = reactive({
        backgroundImage: members.backgroundImage,
    });

    const changeColor = () => {
        members.color = pureColor.value.toString();
        colorOpen.value = false;
    };

    const changeColorBg = () => {
        members.backgroundColor = pureColorBg.value.toString();
        colorOpenBg.value = false;
    };

    const changeBackgroundImage = () => {
        members.backgroundImage = `url(${colorsConfig.backgroundImage})`;
    };

    useClickOutside(colorWidget, () => {
        colorOpen.value = false;
    });
    useClickOutside(colorWidgetBg, () => {
        colorOpenBg.value = false;
    });
</script>
